import React from 'react'
import {
    List,
    Edit,
    DateField,
    ReferenceField,
    BooleanField,
    SimpleForm,
    TextInput,
    Datagrid,
    TextField,
    BooleanInput,
} from 'react-admin'

export const providerProviderEdit = ({ ...props }) => (
    <Edit {...props}>
        <SimpleForm>
            <TextField source="id" />
            <DateField source="created" />
            <DateField source="updated" />
            <BooleanInput source="visible" />
            <ReferenceField source="countryId" reference="common/country">
                <TextField source="name" />
            </ReferenceField>
            <TextInput source="name" />
            <ReferenceField source="currencyId" reference="common/currency">
                <TextField source="name" />
            </ReferenceField>
            <TextInput source="description" />
        </SimpleForm>
    </Edit>
)

export const providerProviderList = (props: any) => {
    return (
        <List {...props}>
            <Datagrid rowClick="edit">
                <TextField source="id" />
                <DateField source="created" />
                <DateField source="updated" />
                <BooleanField source="visible" />
                <ReferenceField source="countryId" reference="common/country">
                    <TextField source="name" />
                </ReferenceField>
                <TextField source="name" />
                <TextField source="currencyId" />
                <TextField source="description" />
            </Datagrid>
        </List>
    )
}
